import { push } from 'connected-react-router';
import { useCallback } from 'react';

import { billingRoutesConfig } from 'domains/account/routes';
import { useAccount } from 'modules/account/hooks/useAccount';
import { useAccountStatus } from 'modules/accountStatus/hooks/useAccountStatus';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';
import { useUpgradePlanDialog } from 'modules/common/components/UpgradePlanDialog';

export interface UsePAYGPlanButtonProps {
  onClickExternal?: () => void;
}

const billingPath = billingRoutesConfig.billing.generatePath();

export const usePAYGPlanButton = ({
  onClickExternal,
}: UsePAYGPlanButtonProps) => {
  const { isLoggedIn } = useAuth();
  const { handleSignIn } = useSSOAuth();
  const { isDev, isFinance } = useAccount();
  const { isFreemium, isPremium } = useAccountStatus();
  const dispatch = useAppDispatch();

  const {
    isOpened: isUpgradePlanDialogOpened,
    onClose: closeUpgradePlanDialog,
    onOpen: openUpgradePlanDialog,
  } = useUpgradePlanDialog();

  const onClick = useCallback(() => {
    onClickExternal?.();

    if (!isLoggedIn) {
      return handleSignIn();
    }

    if (isFreemium && !isFinance) {
      return openUpgradePlanDialog();
    }

    if (isPremium || isFinance) {
      return dispatch(push(billingPath));
    }
  }, [
    dispatch,
    handleSignIn,
    isFinance,
    isFreemium,
    isLoggedIn,
    isPremium,
    onClickExternal,
    openUpgradePlanDialog,
  ]);

  const disabled = isDev;

  return {
    closeUpgradePlanDialog,
    disabled,
    isLoggedIn,
    isUpgradePlanDialogOpened,
    onClick,
  };
};
